import React from 'react';
import { useNavigate } from "react-router-dom";

import {Trans, useTranslation } from 'react-i18next';
import {translateObjectList, arrayBufferToBase64} from "../../Helper"

export function ProviderSummary({provider, inList}) {

    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleReviewsClick = (provider_id) => {
        navigate(`/reviews/${provider_id}`);
    }; 

    const handleLearnMoreClick = (provider_id) => {
        navigate("/provider/"+provider_id);
    }; 

    return (
        <div>
            <div className='center-div mt40 relative'>
                <img src={'/images/avatar.png'} className='avatar-border' alt=''/>
                <div className='avatar-div'>
                    {provider.avatar && <img src={arrayBufferToBase64(provider.avatar)} className='avatar' alt=''/>}
                </div>
            </div>

            <div className='center-div align-items-center'>
                {provider.rating && 
                    <>
                        <div className='text-align-center font-14'>{provider.rating + '/5'}</div>
                        <img src={'/images/star.png'} className='star-icon'  alt=''/>
                    </>
                }

                <span onClick={(e) => handleReviewsClick(provider._id)}>{provider.reviewsCount > 0 ?
                    <div className='text-align-center font-14 font-bold color-93278F'>({provider.reviewsCount})</div> :
                    <img src={'/images/message.png'} className='message-icon' alt=''/>
                }
                </span>
            </div>

            <div className='text-align-center font-20 font-bold'>{(provider.firstName ?? '')+(provider.lastName ? (' '+provider.lastName) : '')}</div>

            <div className='text-align-center font-14'>{translateObjectList(provider.sub_categories, "code", t)}</div> 
            <div className='text-align-center font-20 mt5'>{provider.summary ?? ''}</div>

            {inList &&
                <>
                    <div className='center-div mt20'><div className='shadow-button-list' onClick={() => handleLearnMoreClick(provider._id)}> {t("learn_more")} </div></div>
                    <div className='center-div mt40 mb40'><img src={'/images/list_break.png'} className='width-90' alt=''/></div>
                </>
            }
        </div>
    );
}

export default ProviderSummary;